/**
 * @module timezones
 *
 * Used by entities like companies to select from available timezones.
 */
import { createReducer } from '@reduxjs/toolkit';
import { timezoneActions } from '~/behaviors/actions/timezone.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { companyActions } from '~/behaviors/actions/company.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeTimezones = (state, action) => {
  const timezones = action?.payload?.entities?.timezones || {};

  Object.values(timezones).forEach((timezone) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[timezone.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[timezone.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...timezone,
    };
  });
};

const timezones = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(companyActions.fetchCompany.fulfilled, mergeTimezones);
  builder.addCase(companyActions.modifyCompany.fulfilled, mergeTimezones);
  builder.addCase(timezoneActions.fetchTimezones.fulfilled, mergeTimezones);
});

export default timezones;
